export default {
    when() {
      return document.querySelectorAll('.dropdown-navigation-link').length > 0;
    },
  
    mounted() {
      let buttons = document.querySelectorAll('.dropdown-navigation-link');
      let dropdowns = document.querySelectorAll('.dropdown-navigation-content');
      
      document.addEventListener(
        'mouseover',
        (event) => {
          
          
          buttons.forEach((button) => {
            let withinBoundaries = event.composedPath().includes(button.nextElementSibling);
            let insideButton = event.composedPath().includes(button);
            if (withinBoundaries || insideButton) {
              button.nextElementSibling.classList.remove('hidden');
            } else {
              button.nextElementSibling.classList.add('hidden');
            }
          });
        },
        { passive: true }
      );
    },
  };
  